import { graphql } from './gql';

/**
 * The desk's search box (doc 56): a pasted id is tried on every kind of
 * record at once; a receipt number on payments; other text on names, meter
 * numbers and letter references.
 */
export const DeskFindDocument = graphql(`
  query DeskFind(
    $id: UUID!
    $byId: Boolean!
    $text: String!
    $byText: Boolean!
    $receiptNo: String!
    $byReceipt: Boolean!
  ) {
    member(id: $id) @include(if: $byId) {
      id
      fullName
    }
    meter(id: $id) @include(if: $byId) {
      id
      label
      member {
        fullName
      }
    }
    bill(id: $id) @include(if: $byId) {
      id
      billMonth
      member {
        fullName
      }
    }
    payment(id: $id) @include(if: $byId) {
      ...DeskFoundPayment
    }
    financialOperation(id: $id) @include(if: $byId) {
      id
      date
      type
      amount
      description
    }
    accountTransfer(id: $id) @include(if: $byId) {
      id
      date
      amount
    }
    debt(id: $id) @include(if: $byId) {
      id
      purpose
      counterparty {
        name
      }
    }
    inKindContribution(id: $id) @include(if: $byId) {
      id
      description
    }
    associationDocument(id: $id) @include(if: $byId) {
      id
      title
      reference
    }
    bankStatement(id: $id) @include(if: $byId) {
      id
      periodStart
      periodEnd
    }
    bankStatementLine(id: $id) @include(if: $byId) {
      id
      statementId
      lineNo
      label
    }
    project(id: $id) @include(if: $byId) {
      id
      name
    }
    counterparty(id: $id) @include(if: $byId) {
      id
      name
    }
    financialAccount(id: $id) @include(if: $byId) {
      id
      name
    }
    operationCategory(id: $id) @include(if: $byId) {
      id
      name
    }
    paymentByReceiptNo(receiptNo: $receiptNo) @include(if: $byReceipt) {
      ...DeskFoundPayment
    }
    members(
      filter: { fullName: { includesInsensitive: $text } }
      first: 6
      orderBy: [LAST_NAME_ASC]
    ) @include(if: $byText) {
      nodes {
        id
        fullName
      }
    }
    meters(
      filter: {
        or: [
          { meterNo: { includesInsensitive: $text } }
          { label: { includesInsensitive: $text } }
        ]
      }
      first: 6
    ) @include(if: $byText) {
      nodes {
        id
        label
        member {
          fullName
        }
      }
    }
    associationDocuments(
      filter: {
        or: [
          { reference: { includesInsensitive: $text } }
          { title: { includesInsensitive: $text } }
        ]
      }
      first: 5
      orderBy: [DOCUMENT_DATE_DESC]
    ) @include(if: $byText) {
      nodes {
        id
        title
        reference
      }
    }
    projects(filter: { name: { includesInsensitive: $text } }, first: 4)
      @include(if: $byText) {
      nodes {
        id
        name
      }
    }
    counterparties(filter: { name: { includesInsensitive: $text } }, first: 4)
      @include(if: $byText) {
      nodes {
        id
        name
      }
    }
  }

  fragment DeskFoundPayment on Payment {
    id
    receiptNo
    billId
    bill {
      member {
        fullName
      }
    }
  }
`);
